import { Component, ContentChild, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DeloitteAiCardActionDirective } from "./card-action";

export interface Feature {
    name: string;
    rank: number;
}

export interface Sku {
    sku_id: string;
    rank: number;
    name: string;
    description: string;
    features_available: Array<Feature>;
    features_unavailable: Array<Feature>;
    badge: string | null;
}

@Component({
    selector: "deloitteai-sku-card",
    templateUrl: "./sku-card.html",
    styleUrls: ["./sku-card.scss"],
})
export class DeloitteAiSkuCardComponent implements OnInit {
    public skuData: Sku;
    private tailClass = "sku_card--tail";
    public showTailClass;

    @Input()
    public set sku(sku: Sku) {
        this.skuData = sku;
    }

    @Input()
    public showTail: boolean;

    @ContentChild(DeloitteAiCardActionDirective)
    public actionTrigger: DeloitteAiCardActionDirective;

    ngOnInit(): void {
        if (this.showTail) {
            this.addTail();
        }
    }

    // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
    public get sku(): Sku {
        return this.skuData;
    }

    public addTail(): void {
        this.showTailClass = this.tailClass;
    }

    public removeTail(): void {
        this.showTailClass = "";
    }

    @Output()
    public enableSku: EventEmitter<Sku> = new EventEmitter();

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public triggerAction($event: any): void {
        $event.stopPropagation();
        this.enableSku.emit(this.sku);
    }
}
